export default {"src":"/_next/static/media/EGO.e785a23e.svg","height":18,"width":18};